module.exports = __webpack_public_path__ + "img/dragonslair (3).cc8d9b78.jpg";